
export default {
  hero: {
    badge: 'Partnership Opportunity',
    title: 'Become Our Partner',
    subtitle: 'Join The Daeg International Trade - Build a Successful Business Together',
    description: 'We are looking for strategic partners to expand our business network in Asia and Europe. Join us to create sustainable value and grow together.',
    stats: {
      commission: { value: 'Attractive', label: 'Commission' },
      support: { value: '100%', label: 'Support' },
      experience: { value: '5+', label: 'Years Experience' },
    },
    ctaPrimary: 'Register Partnership Now',
    ctaSecondary: 'Learn About Benefits',
  },
  intro: {
    title: 'Partnership Opportunity',
    heading: 'Expand Services, Increase Revenue with The Daeg',
    description1: 'The Daeg International Trade is seeking strategic partners to expand our business network in Asia and Europe. With over 5 years of experience in import-export and international investment, we have built a solid foundation and are ready to share success with partners.',
    description2: 'We offer attractive partnership opportunities with clear benefits, professional support, and sustainable growth potential.',
    badge: 'Experience',
    badgeValue: '5+ Years',
  },
  benefits: {
    title: 'Partnership Benefits',
    badge: 'Benefits',
    subtitle: 'We are committed to bringing real value to partners with comprehensive support policies',
    items: [
      { title: 'Attractive Commission', description: 'Receive competitive commission from each successful deal' },
      { title: 'Professional Support', description: 'Full support from our expert team throughout the process' },
      { title: 'Quality Products', description: 'Access to quality products and services from The Daeg' },
      { title: 'Training & Development', description: 'Regular training programs to enhance professional skills' },
      { title: 'Marketing Support', description: 'Marketing materials and promotional tools provided' },
      { title: 'Long-term Cooperation', description: 'Build sustainable partnership relationships for mutual growth' },
    ],
  },
  target: {
    title: 'Who We Are Looking For',
    badge: 'Target',
    subtitle: 'We welcome cooperation with organizations and individuals with the same vision for development',
    items: [
      { title: 'Immigration Consultants', description: 'Consultants with experience in immigration and international investment' },
      { title: 'Real Estate Agents', description: 'Real estate agents with extensive customer networks' },
      { title: 'Financial Advisors', description: 'Financial experts with knowledge of international investment' },
      { title: 'Business Organizations', description: 'Organizations and businesses wanting to expand services' },
    ],
  },
  whyPartner: {
    title: 'Why Partner With Us',
    badge: 'Strengths',
    subtitle: 'Reasons why Latvia residency investment program through The Daeg becomes the top choice',
    items: [
      { title: 'Reputable Brand', description: 'The Daeg International Trade - Trusted brand with 5+ years of experience' },
      { title: 'Real Business', description: 'Own Asian Alley supermarket chain with stable revenue' },
      { title: 'High Success Rate', description: '98% success rate in Latvia residency applications' },
      { title: 'Professional Process', description: 'Clear, transparent process with full legal support' },
      { title: 'Reasonable Investment', description: 'Investment from €50,000 — much lower than Golden Visa programs in Portugal, Greece or Spain.' },
      { title: 'European Residence Card', description: 'Investors receive Latvia Residence Card, free travel to 27 Schengen countries, opening the door to Europe for the whole family.' },
      { title: 'Fast Processing', description: 'Fast approval process, usually only 2-4 months. No long waiting like other programs.' },
      { title: 'Growth Potential', description: 'Asian food market in Baltics is growing strongly. Investors not only get residence card but also profit from business.' },
    ],
  },
  process: {
    title: 'Partnership Process',
    badge: 'Process',
    heading: 'Start Partnership in Just 4 Steps',
    subtitle: 'Simple, fast process to become an official partner of The Daeg',
    steps: [
      { title: 'Register Interest', description: 'Fill out the partnership registration form' },
      { title: 'Initial Meeting', description: 'Meet to discuss cooperation opportunities' },
      { title: 'Sign Agreement', description: 'Sign partnership agreement' },
      { title: 'Training', description: 'Participate in training program' },
      { title: 'Start Cooperation', description: 'Begin partnership activities' },
    ],
  },
  form: {
    badge: 'Contact Us',
    title: 'Ready to Become a Partner?',
    description: 'Fill out the form to register for partnership. Our team will contact you within 24 hours to discuss the program in detail.',
    formTitle: 'Partnership Registration',
    contact: {
      hotlineLabel: 'Partnership Hotline',
      emailLabel: 'Partnership Email',
      addressLabel: 'Headquarters',
    },
    commitment: {
      badge: 'Our Commitment',
      quote: '"We are not just looking for business partners, but for people who share the same vision — building bridges between Vietnam and Europe, bringing real opportunities to every family."',
    },
    labels: {
      companyName: 'Company / Organization',
      contactPerson: 'Contact Person',
      phone: 'Phone Number',
      email: 'Email',
      website: 'Website',
      experience: 'Residency Experience',
      message: 'Message',
    },
    placeholders: {
      companyName: 'Enter company name',
      contactPerson: 'Full name',
      phone: 'Phone number',
      email: 'Contact email',
      website: 'https://...',
      experience: 'Select experience',
      message: 'Tell us more about your organization (max 500 characters)',
    },
    experienceOptions: ['Less than 1 year', '1 - 3 years', '3 - 5 years', 'Over 5 years'],
    required: '*',
    charCount: 'characters',
    submit: 'Submit Partnership Registration',
    submitting: 'Submitting...',
    success: 'Partnership registration successful! We will contact you within 24 hours.',
    error: 'An error occurred. Please try again later.',
  },
} as const;
